import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from '../config/api';
import { BoSpinnerService } from '../../shared';
import { tap } from 'rxjs/operators';

@Injectable()
export class PrintCustomerStatementService {
    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
    ) { }

    public printPDF(id: string) {
        this._spinner.show();
        return this._http.get(`${API.PRINT_CUSTOMER_STATEMENT.PRINT(id)}`, { responseType: 'blob' }).pipe(tap(() => this._spinner.hide()));
    }
}
